import { THINSP } from 'utils/characters.js';
import info from './currencies.json';

function toValue(str, currency) {
  if (!str) {
    return 0;
  }
  const { minor } = info[currency];
  const scale = 10 ** (minor || 0);
  return Math.round(Number(str.replace(/[^0-9.,]/g, '').replace(/[.,]/, '.')) * scale);
}

function fromValue(val, currency, withSymbol) {
  const { symbol, minor = 0 } = info[currency];
  const scale = 10 ** (minor);
  const str = (val / scale).toFixed(minor);
  return withSymbol ? `${symbol}${THINSP}${str}` : str;
}

const currencies = { info, toValue, fromValue };

function initialize() {
  if (currencies.list) {
    return;
  }
  currencies.list = Object.keys(info).sort((a, b) => a > b ? 1 : -1);
  currencies.options = currencies.list.map((currency) => ({
    value: currency,
    label: `${currency} (${info[currency].name})`,
  }));
}

initialize();

export default currencies;
